import Accolades from "./accolades";
import BioImage from "./bio-image";
import {
  getEntityLabel,
  getContactButtonText,
  getTitleBase,
  getCorrectOffSalesRegion,
} from "../shared/util";
import Helmet from "react-helmet";
import { Link } from "react-router";
import Press from "../homepage/press/press";
import PropTypes from "prop-types";
import React, { Component } from "react";
import TeamMembers from "./team/";
import Video from "./video";

import "./about.scss";
class About extends Component {
  render() {
    const entity = this.props.entity;
    const tout = entity.siteOptions.showTout ? (
      <p
        dangerouslySetInnerHTML={{ __html: entity.siteOptions.privateTout }}
      ></p>
    ) : null;
    const title = `About - ${getTitleBase(entity)}`;
    return (
      <div className="about-page web-container container">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`Ready to start your home search or place your home on the market? Learn more about ${
              entity.displayName
            } ${getCorrectOffSalesRegion(entity)} real estate ${getEntityLabel(
              entity
            ).toLowerCase()} of ${entity.brand} Inc.`}
          />
        </Helmet>
        <div className="page-header">
          <h1>About</h1>
          <div className="header-separator"></div>
        </div>
        <Video
          bcVideoRefId={entity.bcVideoRefId}
          title={`${entity.displayName} video`}
        />
        <div className="name-intro">
          <h2>{entity.displayName}</h2>
          <span className="sub-header">{entity.title ? entity.title : ""}</span>
          <span className="sub-header">{entity.license}</span>
          {tout}
        </div>
        <div className="spacer-2"></div>
        <div className="row">
          <BioImage entity={entity} />
        </div>
        <TeamMembers entity={entity} />
        <Accolades
          accolades={entity.siteOptions.accolades}
          showAccolades={entity.siteOptions.showAccolades}
        />
        <div className="about-press">
          <Press
            pressItems={this.props.press.results}
            defaultOptions={this.props.defaultOptions}
          />
        </div>
        <div className="work-with-me">
          <Link className="aw-button" to="/contact">
            {getContactButtonText(entity)}
          </Link>
        </div>
        <div style={{ height: "100px" }} />
      </div>
    );
  }
}

About.propTypes = {
  entity: PropTypes.object.isRequired,
  defaultOptions: PropTypes.object.isRequired,
  press: PropTypes.object.isRequired,
};

export default About;



// WEBPACK FOOTER //
// ./src/components/about/about.js